// @ts-nocheck
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./MainPage.module.scss";
import { useNavigate, useParams } from "react-router-dom";
import useDeviceStore from "store/DeviceStore";
import { getDeviceInfo } from "common/commonFunctions";
import useErrorStore from "store/errorStore";
import useUrlData from "store/DataStore";

const MainPage = () => {
  const { t } = useTranslation();
  const { id: orderId } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [status, setStatus] = useState("Conectando...");
  const { setDevice } = useDeviceStore();
  const { networkErr } = useErrorStore((state: any) => state);
  const { fetchOrderData, data: allData, loading, error } = useUrlData();
  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setStatus("Buscando datos de pago..."), 800);
    const t2 = setTimeout(() => setStatus("Preparando..."), 1600);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  useEffect(() => {
    if (orderId) {
      fetchOrderData(orderId)
        .then(() => setDataLoaded(true))
        .catch(() => setDataLoaded(true));
    }
  }, [orderId, fetchOrderData]);

  useEffect(() => { getDeviceInfo(setDevice); }, [networkErr, setDevice]);

  useEffect(() => {
    if (!dataLoaded || loading) return;
    if (error) { navigate(`/canceled/${orderId}?type=notfound`, { replace: true }); return; }
    
    const status = allData.status_name?.toLowerCase();
    if (status === 'expired') { navigate(`/canceled/${orderId}?type=expired`, { replace: true }); return; }
    if (status === 'cancelled' || status === 'canceled') { navigate(`/canceled/${orderId}?type=canceled`, { replace: true }); return; }
    if (status === 'completed' || status === 'finished' || status === 'success') { navigate(`/success/${orderId}`, { replace: true }); return; }

    const method = allData.transfer_method?.toLowerCase();
    const timer = setTimeout(() => {
      if (method === 'qr' || method === 'qrpay') navigate(`/qrpay/${orderId}`, { replace: true });
      else navigate(`/cbu/${orderId}`, { replace: true });
    }, 1500);
    return () => clearTimeout(timer);
  }, [dataLoaded, loading, error, allData.transfer_method, allData.status_name, orderId, navigate]);

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <span className={styles.logo}>PagoPay</span>
        <span className={styles.orderId}>{orderId?.slice(0, 8)}</span>
      </header>

      <div className={styles.content}>
        <div className={styles.loader}>
          <div className={styles.spinner} />
        </div>
        <div className={styles.status}>{status}</div>
        <div className={styles.hint}>Por favor espere</div>
      </div>

      <footer className={styles.footer}>
        <span>Conexión segura</span>
      </footer>
    </div>
  );
};

export default MainPage;
